import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { IonIcon, IonText } from "@ionic/vue";
import { useRouter } from "vue-router";
import { personCircleSharp } from "ionicons/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuUserLoginItem',
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const emit = __emit;
const goToLogin = () => {
  emit("onClose");
  router.push("/login");
};

const goToSingup = () => {
  emit("onClose");
  router.push("/signup");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonIcon), {
      class: "avatar-img",
      icon: _unref(personCircleSharp)
    }, null, 8, ["icon"]),
    _createElementVNode("div", null, [
      _createVNode(_unref(IonText), {
        class: "auth-link",
        onClick: goToLogin
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Login ")
        ]),
        _: 1
      }),
      _createVNode(_unref(IonText), null, {
        default: _withCtx(() => [
          _createTextVNode(" or ")
        ]),
        _: 1
      }),
      _createVNode(_unref(IonText), {
        class: "auth-link",
        onClick: goToSingup
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Register ")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})